import React, { useContext } from 'react'
import { ItemType, LifeCycle, Priority, Progress, TodoContext } from './Project'
import Todo from './Todo';
import { v4 as uuidv4 } from 'uuid';

export default function TodoNow() {  
  const {tasks, setTasks} = useContext(TodoContext);
  const lines = tasks.filter(task => task.priority === Priority.Now && task.progress !== Progress.Done);

  const addTodoNow = (e) => {
    setTasks([{
        id: uuidv4(),
        text: ``,
        priority: Priority.Now,
        lifeCycle: LifeCycle.Code,
        progress: Progress.Pending,
        itemType: ItemType.Task,
        kiponosInfo: {isNew:true}
    }, ...tasks]);
  }

  return (
    <Todo title='Todo Now' lines={lines} titleStyle='titleNow' anAdd={addTodoNow}/>
  )
}
